import ModalTextField from 'components/ModalTextField';
import { ChartFormField } from 'interfaces/components/modalTextField';
import { ChartFieldValue } from 'interfaces/store/chartForms';
import InfoGreyIcon from 'assets/icons/info-grey.svg';
import { CalculateFieldNames } from 'utils/constants/fieldNames';

interface ChartsFormTextFieldProps {
  field: ChartFormField;
  disabled: boolean;
  getFieldValue: (name: ChartFieldValue) => string;
  handleFieldChange: (name: ChartFieldValue, value: string) => void;
  annualRevenue?: string | null;
}

const ChartsFormTextField = ({
  field,
  disabled,
  getFieldValue,
  handleFieldChange,
  annualRevenue
}: ChartsFormTextFieldProps) => {
  const isAbsoluteOpExField = [
    'ga_absolute_opex',
    'sm_absolute_opex',
    'rd_absolute_opex'
  ].includes(field.name);

  const isDisabled = isAbsoluteOpExField && !annualRevenue;

  const handleChange = (value: string) => {
    if (isAbsoluteOpExField) {
      const gaOpEx =
        field.name === CalculateFieldNames.GA_ABSOLUTE_OPEX
          ? value
          : getFieldValue(CalculateFieldNames.GA_ABSOLUTE_OPEX);
      const smOpEx =
        field.name === CalculateFieldNames.SM_ABSOLUTE_OPEX
          ? value
          : getFieldValue(CalculateFieldNames.SM_ABSOLUTE_OPEX);
      const rdOpEx =
        field.name === CalculateFieldNames.RD_ABSOLUTE_OPEX
          ? value
          : getFieldValue(CalculateFieldNames.RD_ABSOLUTE_OPEX);

      const totalOpEx =
        (Number(gaOpEx) || 0) + (Number(smOpEx) || 0) + (Number(rdOpEx) || 0);

      handleFieldChange(field.name, value);
      handleFieldChange(CalculateFieldNames.TOTAL_OPEX, totalOpEx.toString());
    } else {
      handleFieldChange(field.name, value);
    }
  };

  return (
    <ModalTextField
      {...field}
      disabled={disabled || isDisabled}
      value={getFieldValue(field.name)}
      onChange={handleChange}
      height='h-[35px]'
      inputStyle='!text-base'
      labelStyle='text-sm'
      character={isAbsoluteOpExField && annualRevenue ? '$' : field.character}
      isPrefixCharacter={
        isAbsoluteOpExField && !!annualRevenue ? true : field.isPrefixCharacter
      }
      placeholder={
        isAbsoluteOpExField && !annualRevenue ? 'N/A' : field.placeholder
      }
      infoIcon={InfoGreyIcon}
      showInfoIcon={isDisabled}
      tooltipListTitle='Please enter Annual Revenue to enter a $ amount for OpEx as a % of Revenue'
    />
  );
};

export default ChartsFormTextField;
